import React, { useContext, useEffect, useState } from 'react';
import './StenographDisplay.css'; 
import StenographWaveform from './StenographWaveform';
import CustomToolTipHost from '../../../../components/CustomToolTipHost/CustomToolTipHost';
import AgenticReportingContext from '../../../../context/agentic-reporting/AgenticReportingContext';

const StenographDisplay = ({ baseBorderStyle }) => {

  const{
    stenographState,
    vapiFunctions,
    isVapiConnecting
  } = useContext(AgenticReportingContext);

  const [visualState, setVisualState] = useState({
    amplitude: 0,
    userSpeaking: false
  });

  useEffect(() => {
    const handleAudioUpdate = (event) => {
      setVisualState({
        amplitude: event.detail.amplitude,
        userSpeaking: event.detail.userSpeaking
      });
    };

    window.addEventListener('vapi-audio-level', handleAudioUpdate);
    return () => window.removeEventListener('vapi-audio-level', handleAudioUpdate);
  }, []);

  const isMuted = stenographState.isMuted;

  const tooltipStyleProps = {
    calloutProps: {
      styles: {
        beak: { background: "#252525" },
        beakCurtain: { background: "#252525" },
        calloutMain: { background: "#252525", borderRadius: "4px" }, 
      },
    },
  };

  return (
    <div 
      className="stenograph-container"
      style={{
        ...baseBorderStyle,
        borderRadius: '4px',    
      }}
    >
      {isVapiConnecting ? (
        <div style={{ 
            position: 'absolute',
            width: '100%', 
            textAlign: 'center',
            color: '#888', 
            fontSize: '14px', 
            fontStyle: 'italic', 
            zIndex: 1 
          }}>
          Getting ready...
        </div>
      ) : (
        <StenographWaveform
          userSpeaking={!isMuted && visualState.userSpeaking}
          amplitude={isMuted ? 0 : visualState.amplitude}
          assistantSpeaking={stenographState.assistantSpeaking}
        />
      )}
      
      <div className="stenograph-controls">
        <CustomToolTipHost 
          content={isMuted ? "Turn on microphone" : "Turn off microphone"} 
          id="MuteToggle" 
          tooltipProps={tooltipStyleProps}
        >
          <button 
            className="steno-button mute" 
            aria-label={isMuted ? "Unmute" : "Mute"}
            onClick={vapiFunctions.toggleMute}
            disabled={isVapiConnecting} 
            style={{ 
              cursor: isVapiConnecting ? 'not-allowed' : 'pointer', 
              color: isVapiConnecting ? '#A19F9D' : (isMuted ? '#ef4444' : '#333') 
            }}
          >
            {isMuted ? (
              <svg width="18" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="1" y1="1" x2="23" y2="23"></line><path d="M9 9v3a3 3 0 0 0 5.12 2.12M15 9.34V4a3 3 0 0 0-5.94 0"></path><path d="M17 16.95A7 7 0 0 1 5 12v-2m14 0v2a7 7 0 0 1-.11 1.23"></path><line x1="12" y1="19" x2="12" y2="23"></line><line x1="8" y1="23" x2="16" y2="23"></line></svg>
            ) : (
              <svg width="18" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M12 1a3 3 0 0 0-3 3v8a3 3 0 0 0 6 0V4a3 3 0 0 0-3-3z"></path><path d="M19 10v2a7 7 0 0 1-14 0v-2"></path><line x1="12" y1="19" x2="12" y2="23"></line><line x1="8" y1="23" x2="16" y2="23"></line></svg>
            )}
          </button>
        </CustomToolTipHost>

        <CustomToolTipHost 
          content="Stop" 
          id="EndCall" 
          tooltipProps={tooltipStyleProps}
        >
          <button 
            className="steno-button cancel"
            aria-label="Cancel" 
            onClick={vapiFunctions.cancelVapiTranscript}
          >
            ✕
          </button>
        </CustomToolTipHost>
      </div>
    </div>
  );
};

export default StenographDisplay;